import _ from "lodash";
import { useRef } from "react";
import { DataTable } from "primereact/datatable";
import { Toast } from "primereact/toast";
import { Column } from "primereact/column";
import ACPFilter from "../ACP/common/ACPFilter";
import DesignJobsHeader from "./DesignJobsHeader";
import { bufferToWork, changeDateFormat, showToast, toastMessages } from "../../utils";
import { AcpService } from "../../service/ACPService";
import { AcpCommonService } from "../../service/AcpCommonService";
import { colNameMapping } from "./utils";
import { downloadAzureContainer } from "../../apis/downloadAzureContainer";

import "./index.scss";

function DesignJobsList({
  projectColumnName,
  selectedColumnList,
  selectedFieldsRef,
  initialDesignJobsData,
  designJobsData,
  setDesignJobsData,
  selectedJobsData,
  setSelectedJobsData,
  selectAllChecked,
  setSelectAllChecked,
  selectAllCheckedDisabled,
  setConditionMatched,
  filterDesignJobsData,
  onGlobalFilterChange,
  setFilterDesignJobsData,
  resetKey,
  setResetKey,
  isSearch,
  tableLoader,
  setShowWarning,
  onSort,
  selectedColumnName,
  setSelectedColumnName,
  sortData,
  setSortData,
  selectedFields,
  frozenColumns,
  setSelectedFields,
  setShowPDFViewer,
  setPDFViewerInfo,
  searchHeader,
  designJobWrapFreeText,
  setDesignJobId,
  setSelectedMarkUp,
  setShowVersionPopUp,
  setShowMarkupPopUp,
  setSelectedJobVersionDetails,
  projectDetails,
  clearAll,
}) {  
  const op = useRef(null);
  const toast = useRef(null);

  const onColumnResizeEnd = (event) => {};

  const storeReorderedColumns = (event) => {};

  const clearColumnWiseFilter = () => {
    let _selectedColumnName = selectedColumnName;
    let jsonSortItem = localStorage.getItem("sortingData");
    const sortItem = JSON.parse(jsonSortItem);
    if (sortItem && sortItem.length && sortItem[0] === selectedColumnName) {
      localStorage.setItem("sortingData", JSON.stringify([]));
    }
    if (sortData && sortData?.length && sortData[0] === _selectedColumnName) {
      setSortData([]);
    }

    const selectedFields2 = _.cloneDeep(selectedFields);
    const _selectedFields = AcpService.emptyProperty(selectedFields2, _selectedColumnName);
    const __selectedFields = AcpCommonService.removeEmptyArraysWithNoData(_selectedFields);

    let data = [];
    if (Object.keys(__selectedFields)?.length) {
      data = [...(designJobsData || [])];
      Object.keys(__selectedFields).forEach((el) => {
        if (__selectedFields[el]?.length) {
          data = data.filter((ele) => __selectedFields[el].includes(ele[el]));
        }
      });
    }

    if (data?.length && Object.keys(__selectedFields)?.length) {
      setFilterDesignJobsData(data);
    } else if (sortData?.length && sortData[0] !== _selectedColumnName) {
      selectedColumnList.current = designJobsData;
      setFilterDesignJobsData([]);
      onSort(sortData[0], sortData[1], designJobsData);
    } else {
      setFilterDesignJobsData([]);
      const finalInitialData = _.cloneDeep(initialDesignJobsData);
      selectedColumnList.current = finalInitialData;
      setDesignJobsData(finalInitialData);
    }
    setConditionMatched(false);
    selectedFieldsRef.current = __selectedFields;
    setSelectedFields(__selectedFields);
    if (AcpService.areAllPropertiesEmptyArrays(__selectedFields)) {
      localStorage.removeItem("_selectedFieldsRefCurrentDesignJobs");
    }
  };

  const getStatusColor = (status) => {
    switch (status) {
      case "Complete-Approved":
        return "#28a745";
      case "In-Progress":
        return "#007bff";
      case "In-Progress-Rejected":
        return "#dc3545";
      case "Complete-Rejected":
        return "#dc3545";
      case "Awaiting":
        return "#e9f98e";
      default:
        return "#6c757d";
    }
  };

  // Status cell with icon and color for Jobs grid
  const statusIconCell = (rowData) => {
    if (rowData.Status === "Complete-Approved") {
      return (
        <div
          className="text-center"
          style={{ color: getStatusColor(rowData.Status), fontWeight: 500 }}
        >
          <i className="pi pi-check status-icons"></i>
        </div>
      );
    }

    if (rowData.Status === "In-Progress") {
      return (
        <div
          className="text-center"
          style={{ color: getStatusColor(rowData.Status), fontWeight: 500 }}
        >
          <i className="pi pi-refresh status-icons"></i>
        </div>
      );
    }

    if (rowData.Status === "In-Progress-Rejected") {
      return (
        <div
          className="text-center"
          style={{ color: getStatusColor(rowData.Status), fontWeight: 500 }}
        >
          <i className="pi pi-refresh status-icons"></i>
        </div>
      );
    }

    if (rowData.Status === "Complete-Rejected") {
      return (
        <div
          className="text-center"
          style={{ color: getStatusColor(rowData.Status), fontWeight: 500 }}
        >
          <i className="pi pi-times status-icons"></i>
        </div>
      );
    }
    if (rowData.Status === "Awaiting") {
      return (
        <div
          className="text-center"
          style={{ color: getStatusColor(rowData.Status), fontWeight: 500 }}
        >
          <i className="pi pi-hourglass status-icons"></i>
        </div>
      );
    }
    return (
      <div
        className="text-center"
        style={{ color: getStatusColor(rowData.Status), fontWeight: 500 }}
      >
        {rowData.Status}
      </div>
    );
  };

  const openPDFViewer = (e, jobName, proofScopeURL) => {
    e.preventDefault();
    setShowPDFViewer(true);
    setPDFViewerInfo({
      headerName: jobName,
      proofscopeURL: proofScopeURL,
    });
  };

  const openVersionList = (e, options) => {
    e.preventDefault();
    setSelectedJobVersionDetails({
      jobName: options?.DesignJobName,
      jobId: options?.DesignJobID,
      folderName: options?.FolderName,
    });
    setShowVersionPopUp(true);
  };

  const handleMarkupPopup = (selectedMarkup = "") => {
    setSelectedMarkUp(selectedMarkup);
    setShowMarkupPopUp(true);
  };

  const downloadPdf = async (e, colDetails) => {
    e.preventDefault();

    const targetFolder = "TD";

    // Find the folder that exists in the file path
    const matchedFolder = colDetails?.Filepath_DesignJobs?.endsWith(".pdf")
      ? colDetails?.Filepath_DesignJobs?.includes(targetFolder)
      : "";
    const fileGroup = colDetails?.FileGroup;

    const basePath = `${projectDetails?.BU}/${
      projectDetails?.Region
    }/${projectDetails?.ProjectID?.toUpperCase()}/${colDetails?.FolderName}/${colDetails?.DesignJobID}`;

    let folderStructure = "";

    if (matchedFolder) {
      folderStructure = `${basePath}/${targetFolder}/${colDetails?.FileVersion}`;
    } else if (fileGroup) {
      folderStructure = `${basePath}/${fileGroup}/${colDetails?.FileVersion}`;
    } else {
      folderStructure = `${basePath}/${colDetails?.FileVersion}`;
    }

    try {
      await downloadAzureContainer(colDetails?.FileName?.replaceAll("%20", " "), folderStructure);

      // Show success toast once download is complete
      showToast(toast, "success", toastMessages.downloadComplete.detail, {
        life: 3000,
        clearPrevious: true,
      });
    } catch (error) {
      // Show error toast if the download fails
      showToast(toast, "error", toastMessages.downloadFailed.detail, {
        life: 3000,
        clearPrevious: true,
      });
    }
  };

  const handleSelect = (event, options) => {
    let designJobsDataMod = [],
      filterDesignJobsDataMod = [];

    if (event?.target?.checked) {
      const tempObj = {
        bu: projectDetails?.BU,
        region: projectDetails?.Region,
        projectId: options?.AWMProjectID,
        jobName: options?.FolderName,
        designJobId: options?.DesignJobID,
        fileVersion: options?.FileVersion
      };

      designJobsDataMod = _.cloneDeep(designJobsData).map((data) => ({
        ...data,
        selected: data?.DesignJobID === options?.DesignJobID ? true : data?.selected,
      }));

      filterDesignJobsDataMod = _.cloneDeep(filterDesignJobsData).map((data) => ({
        ...data,
        selected: data?.DesignJobID === options?.DesignJobID ? true : data?.selected,
      }));

      setSelectedJobsData((prevData) => [...prevData, tempObj]);
    } else {
      const filterSelectedJobs = selectedJobsData.filter(
        (data) => data?.designJobId !== options?.DesignJobID,
      );

      designJobsDataMod = _.cloneDeep(designJobsData).map((data) => ({
        ...data,
        selected: data?.DesignJobID === options?.DesignJobID ? false : data?.selected,
      }));

      filterDesignJobsDataMod = _.cloneDeep(filterDesignJobsData).map((data) => ({
        ...data,
        selected: data?.DesignJobID === options?.DesignJobID ? false : data?.selected,
      }));

      setSelectedJobsData(filterSelectedJobs);
    }

    setDesignJobsData(designJobsDataMod);
    setFilterDesignJobsData(filterDesignJobsDataMod);
  };

  const renderMappingBody = (options, rowData) => {
    const field = rowData.field;

    return (
      <>
        {(field === "Type" ||
          field === "PMP" ||
          field === "RTA_POA" ||
          field === "Approval" ||
          field === "DSBP_InitiativeID" ||
          field === "DSBP_Initiative_Name" ||
          field === "RTA_ProjectID" ||
          field === "RTA_Project_Name" ||
          field === "PIMaterialNumber" ||
          field === "PIMaterialID" ||
          field === "PIMaterialDescription" ||
          field === "POANumber" ||
          field === "POADescription" ||
          field === "BufferToWorkRatio" ||
          field === "AWM_GroupPMP" ||
          field === "Design" ||
          field === "RDTStatus" ||
          field === "NPFStatus" ||
          field === "Copy" ||
          field === "RTA_RTAPOAStatus" ||
          field === "TDState" ||
          field === "PMPState") &&
          options[field]}
        {field === "field_0" && (
          <div className="flex align-items-center">
            <input
              type="checkbox"
              className="p-checkbox-box p-highlight"
              checked={options?.selected}
              onChange={(event) => handleSelect(event, options)}
              disabled={options?.FileVersion === ""}
            />
          </div>
        )}
        {field === "DesignJobName" &&
          (options["ReadOnlyURL"] ? (
            <a href="#" onClick={(e) => openPDFViewer(e, options[field], options["ReadOnlyURL"])}>
              {options[field]}
            </a>
          ) : (
            <span>{options[field]}</span>
          ))}
        {field === "Markup" && options?.MarkupCount && (
          <div className="text-center">
            <button className="infoButton" onClick={() => handleMarkupPopup(options?.DesignJobID)}>
              <i className="pi pi-info-circle text-danger" style={{ fontSize: "1.2rem" }}></i>
            </button>
          </div>
        )}
        {field === "Version" && options?.FileVersion && (
          <div className="text-center">
            <a href="#" onClick={(e) => openVersionList(e, options)}>
              {options?.FileVersion}
            </a>
          </div>
        )}
        {field === "EndDate" && changeDateFormat(options[field])}
        {field === "BufferToWork" && bufferToWork(options[field])}
        {field === "FilePath" && (
          <div className="text-center">
            {options[field] === "" ? (
              <i className="pi pi-image no-image-icon"></i>
            ) : (
              <img
                src={options[field]}
                alt="N/A"
                className="visual-img"
                onClick={(e) => openPDFViewer(e, options["DesignJobName"], options["ReadOnlyURL"])}
              />
            )}
          </div>
        )}
        {field === "Status" && statusIconCell(options)}
        {field === "Force" && (
          <div className="text-center">
            <button
              className="force-btn"
              disabled={options?.Status === "Awaiting" || options?.IsForceApprove}
              onClick={() => {
                setShowWarning(true);
                setDesignJobId(options?.DesignJobID);
              }}
            >
              <i className="pi pi-check"></i>
            </button>
          </div>
        )}
        {field === "Download" && (
          <div className="text-center">
            <button
              className="download-btn"
              title={options?.FileVersion ? "" : "No files available for download"}
              disabled={!options?.FileVersion}
              onClick={(e) => downloadPdf(e, options)}
            >
              <i className="pi pi-download fs-4"></i>
            </button>
          </div>
        )}
      </>
    );
  };

  const columnNameOnClick = (e, options) => {
    op.current.toggle(e);
    setSelectedColumnName(options);
  };

  const handleSelectAll = (event) => {
    if (event?.target?.checked) {
      let designJobsDataMod = [],
        filterDesignJobsDataMod = [],
        payload = [];

      for (let job of designJobsData) {
        if (job.FileVersion) {
          const tempObj = {
            bu: projectDetails?.BU,
            region: projectDetails?.Region,
            projectId: job?.AWMProjectID,
            jobName: job?.FolderName,
            designJobId: job?.DesignJobID,
            fileVersion: job?.FileVersion
          };

          payload.push(tempObj);
        }
      }

      designJobsDataMod = _.cloneDeep(designJobsData).map((data) => ({
        ...data,
        selected: data?.FileVersion ? true : false,
      }));

      filterDesignJobsDataMod = _.cloneDeep(filterDesignJobsData).map((data) => ({
        ...data,
        selected: data?.FileVersion ? true : false,
      }));

      setSelectedJobsData(payload);
      setDesignJobsData(designJobsDataMod);
      setFilterDesignJobsData(filterDesignJobsDataMod);
      setSelectAllChecked(true);
    } else {
      clearAll();
    }
  };

  const renderCheckboxHeader = () => {
    return (
      <div className="flex align-items-center">
        <input
          type="checkbox"
          className="p-checkbox-box p-highlight"
          checked={selectAllChecked}
          disabled={selectAllCheckedDisabled}
          onChange={handleSelectAll}
        />
      </div>
    );
  };

  const dynamicColumns = () => {
    if (projectColumnName?.length) {
      return [
        <Column
          key="checkbox"
          body={renderMappingBody}
          frozen={true}
          columnKey="checkbox"
          header={() => renderCheckboxHeader()}
          className="checkbox-column"
          headerClassName="checkbox-width"
          bodyClassName="checkbox-width"
        />,
        ...projectColumnName?.map((ele, index) => {
          return (
            <Column
              filter
              key={ele}
              field={ele}
              filterField={ele}
              alignFrozen="left"
              columnKey={ele || index}
              showFilterMenu={false}
              filterPlaceholder={colNameMapping[ele]}
              body={renderMappingBody}
              frozen={frozenColumns?.includes(ele)}
              header={DesignJobsHeader(ele, columnNameOnClick, selectedFields, frozenColumns)}
              className={frozenColumns.includes(ele) ? "font-bold frozen-width" : ""}
              style={{
                whiteSpace: designJobWrapFreeText ? "normal" : "nowrap",
                wordBreak: designJobWrapFreeText ? "break-word" : "unset",
                overflow: designJobWrapFreeText ? "unset" : "hidden",
                textOverflow: designJobWrapFreeText ? "unset" : "ellipsis",
              }}
            />
          );
        }),
        <Column
          key={"Force"}
          field={"Force"}
          alignFrozen="left"
          columnKey={"Force"}
          showFilterMenu={false}
          filterPlaceholder={"Force"}
          body={renderMappingBody}
          header={"Force"}
        />,
        <Column
          key={"Download"}
          field={"Download"}
          alignFrozen="left"
          columnKey={"Download"}
          showFilterMenu={false}
          filterPlaceholder={"Download"}
          body={renderMappingBody}
          header={"Download"}
        />,
      ];
    }
  };

  return (
    <>
      <Toast ref={toast} />
      <ACPFilter
        op={op}
        onSort={onSort}
        sortData={sortData}
        setSortData={setSortData}
        pageName={"designJobs"}
        selectedFields={selectedFields}
        selectAllColumnNotIncluded={true}
        projectData={designJobsData}
        selectedColumnName={selectedColumnName}
        filters={filterDesignJobsData}
        onGlobalFilterChange={onGlobalFilterChange}
        setFilterDesignJobsData={setFilterDesignJobsData}
        clearColumnWiseFilter={clearColumnWiseFilter}
        frozenCoulmns={[]}
        setSelectedColumnName={setSelectedColumnName}
      />
      <DataTable
        filters={searchHeader}
        emptyMessage={tableLoader ? " " : "No jobs found"}
        value={filterDesignJobsData.length ? filterDesignJobsData : designJobsData}
        resizableColumns
        reorderableColumns
        onColumnResizeEnd={onColumnResizeEnd}
        onColReorder={storeReorderedColumns}
        key={resetKey}
        filterDisplay={isSearch && "row"}
        className="mt-3"
        responsiveLayout="scroll"
        scrollable
        tableStyle={{
          width: "max-content",
          minWidth: "100%",
        }}
      >
        {dynamicColumns()}
      </DataTable>
    </>
  );
}

export default DesignJobsList;
